import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { IGerenciadorPrecosDatapoint } from '../../../../@types';

type ModalRowData = Partial<IGerenciadorPrecosDatapoint>;

type RestoreModalRowParams = {
  dispatch: Dispatch<AnyAction>;
  rowData: ModalRowData;
  index: number;
  editedDatapoints: Record<string, ModalRowData>;
  updateDatapoint: (payload: { index: number; updatedData: ModalRowData }) => AnyAction;
  updateEditedDatapoint: (payload: { key: string; updatedData: ModalRowData }) => AnyAction;
};

/**
 * Devolve a linha do modal ao estado que tinha quando o campo recebeu foco.
 * Usado quando o valor digitado é recusado (ex.: margem acima do limite do produto).
 */
export const restoreModalRow = ({
  dispatch,
  rowData,
  index,
  editedDatapoints,
  updateDatapoint,
  updateEditedDatapoint,
}: RestoreModalRowParams): void => {
  dispatch(updateDatapoint({ index, updatedData: rowData }));

  const key = rowData.productsToBePricedId;

  // Só desfaz a edição pendente se a linha já tinha uma: restaurar uma linha
  // intocada a incluiria no payload de "salvar alterações" sem o usuário ter editado
  if (!key || !editedDatapoints[key]) return;

  dispatch(updateEditedDatapoint({ key, updatedData: rowData }));
};
